import styled from '@emotion/styled'
import { colors } from '@mobi/component-library/Theme/Common'
import { BaseButtonStyled } from '@mobi/component-library/Common/Buttons'

interface BonusBetButtonProps {
  selected: boolean
  disabled?: boolean
}

export const BonusBetButtonStyled = styled(BaseButtonStyled)<BonusBetButtonProps>(
  {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    padding: '1rem',
  },

  ({ selected, disabled }) => ({
    background: selected ? colors.white : colors.success[600],
    color: disabled ? 'default' : selected ? colors.black : colors.white,
  })
)
